
<template>
  <div>
    <headerNav></headerNav>
    <div class="menu_box m_clearLR m_tran50">
      <div class="m_clearLR m_floatL m_menu_div_down m_menu_scroll">
        <div
          :topMethod="loadTop"
          :index="index"
          :class="currentindex==index?'active':''"
          v-for="(item,index) in categoryList"
          :key="index"
          @click="tabClick(index)"
        >
          <a href="javascript:void(0);">{{item.name}}</a>
        </div>
      </div>
      <div class="m_floatL m_menu_sx"></div>
      <div class="m_floatR menu_sx m_clearLR" @click="openSx">
        <div class="m_floatR sx_img">
          <img src="./../assets/images/sx.png" />
        </div>
        <div class="m_floatL sx_text">筛选</div>
      </div>
    </div>
    <div></div>
    <div class="loadmore_box m_tran50">
      <mt-loadmore
        :bottomDistance="bottomDistance"
        ref="loadmore"
        :topDistance="mynum"
        @top-status-change="handleTopChange"
        :bottom-method="loadBottom"
        :bottom-all-loaded="allLoaded"
        :max-distance="150"
      >
        <ul class="ulFollower" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading">
          <mt-spinner
            color="rgb(38, 162, 255)"
            class="m_spinner"
            type="triple-bounce"
            v-show="showSpinner"
          ></mt-spinner>
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div class="content swiper-slide" v-for="item in categoryList.length" :key="item">
                <div class="goods_box m_clearLR">
                  <!-- <div class="goods_divTwo" v-for="(item,index) in list" :key="index">
        <div>
          {{item.title}}
        </div>
        <div class="m_clearLR goods_msg_box">
          <div class="m_floatL">
            {{item.views?item.views:'0'}}人阅读
          </div>
          <div class="m_floatL createdTime">
            {{item.created_at|partFilter}}
          </div>
        </div>
                  </div>-->
                </div>
                <div class="wrap" id="wrap">
                  <zpagenav
                    v-bind:page="pageIndex"
                    v-bind:page-size="pageSize"
                    v-bind:total="total"
                    v-bind:max-page="maxPage"
                    v-on:pagehandler="pageHandler"
                  ></zpagenav>
                </div>
              </div>
            </div>
          </div>
        </ul>
        <div slot="top" class="mint-loadmore-top">
          <div
            v-show="topStatus !== 'loading'"
            :class="topStatus=='pull'?'pull':'rotate'"
            class="pullRotate"
          >↓</div>
          <span v-show="topStatus === 'loading'" class="loadingImg">
            <mt-spinner type="fading-circle" color="#26a2ff" :size="mysize"></mt-spinner>
          </span>
        </div>
      </mt-loadmore>
    </div>
    <mt-popup v-model="popupVisible" position="right">
      <div class="sideMenu_box">
        <div class="sideMenu_box_title">筛选</div>
        <div
          class="sideMenu_box_content"
          v-for="(tagCategoryItem,index) in categorySxList"
          :key="index"
        >
          <div class="sideMenu_title">{{tagCategoryItem.verboseName}}</div>
          <div class="sideMenu_div">
            <div
              @click="selectSideMenu"
              :tagId="tagIdItem.id"
              v-for="(tagIdItem,index) in tagCategoryItem.tagId"
              :key="index"
            >{{tagIdItem.value}}</div>
          </div>
        </div>
        <!-- <div class="sideMenu_box_content">
        <div class="sideMenu_title">按品牌</div>
        <div class="sideMenu_div">
          <div    @click="selectSideMenu" v-for="(item,index) in sideArr" :key="index">热敏机</div>

        </div>
        </div>-->
      </div>
      <div class="sideComfirm" @click="comfirmSx">确定</div>
    </mt-popup>
  </div>
</template>

<script>
import Swiper from 'swiper/dist/js/swiper.min.js'
import header from './header'
import { getCategory, getArticle } from '@/api/api'
import axios from 'axios'
export default {
  data () {
    return {
      page: 1, // 显示的是哪一页
      pageSize: 8, // 每一页显示的数据条数
      total: 10, // 记录总数
      maxPage: 9, // 最大页数
      popupVisible: false,
      m_DivShow: false,
      activeIndex: 0,
      textArr: ['标签打印机', '扫描枪', '采集器', '软件'],
      testImg:
        'http://47.106.192.126/media/images/goods/goods_front_image/2018/09/TB229W7jOMnBKNjSZFCXXX0KFXa_931936555.jpg_800x800q90.jpg',
      currentindex: 0,
      showMore: false,
      baseUrl: 'http://39.108.49.16/api/DlabelTemplate/',
      counter: 1,
      num: 27,
      showSpinner: false,
      sideArr: ['热敏机', '热转机', 'D300', 'D200'],
      sideIndex: ['-1', '-1'],
      topStatus: '',
      list: [],
      topStatus: '',
      mynum: 200,
      bottomDistance: 30,
      handler: function (e) {
        e.preventDefault()
      },
      baseUrl: 'http://39.108.49.16/api/DlabelTemplate/',
      mysize: 35,
      pageIndex: 1,
      noDataing: false,
      noDataed: false,
      allLoaded: false,
      openFlag: false,
      listdata: [], // 下拉更新数据存放数组
      downdata: [],
      flag: false,
      sum: 0,
      categoryList: [],
      categorySxList: [],
      str: '',
      flag: false,
      getListFlag: false,
      mySwiperTwo: {}
    }
  },
  components: {
    headerNav: header
  },
  created () {
    getCategory().then(res => {
      this.categoryList = res.data
      if (this.categoryList) {
        this.categorySxList = this.categoryList[this.currentindex].tagCategory
      }
      this.pageIndex = 1
      this.getList()
    })
  },
  filters: {
    // 转化时间年月日
    // partFilter: function(value, type) {
    //   if (!value) return "";
    //   var time = value.split("T")[0];
    //   var year = time.split("-");
    //   value = year[0] + "年" + year[1] + "月" + year[2] + "日";
    //   return value;
    // }
  },
  methods: {
    pageHandler: function (page) {
      // here you can do custom state update
      this.pageIndex = page
      this.getList()
    },
    partFilter (value) {
      if (!value) return ''
      var time = value.split('T')[0]
      var year = time.split('-')
      value = year[0] + '年' + year[1] + '月' + year[2] + '日'
      return value
    },
    comfirmSx () {
      this.pageHandler(1)
      return

      this.str =
        '?article_type=2&category=' + this.categoryList[this.currentindex].id
      var actives = document.querySelectorAll('.sideMenu_div .active')
      for (var i = 0; i < actives.length; i++) {
        this.str += '&tags=' + actives[i].getAttribute('tagid')
      }
      this.showSpinner = true
      getArticle(
        this.str + '&page=' + this.pageIndex + '&page_size=' + this.pageSize
      )
        .then(res => {
          this.list = res.data.results
          if (this.list.length <= 0) {
            this.noData()
          }
          var strs = document.querySelector('.swiper-slide-active .goods_box')
          strs.innerHTML = ''
          for (var i = 0; i < this.list.length; i++) {
            strs.innerHTML +=
              '<div class="goods_divTwo" tag=' +
              this.list[i].id +
              '><div>' +
              this.list[i].title +
              '</div><div class="m_clearLR goods_msg_box">' +
              '<div class="m_floatL">' +
              (this.list[i].views ? this.list[i].views : '0') +
              '人阅读</div><div class="m_floatL createdTime">' +
              this.partFilter(this.list[i].created_at) +
              '</div></div></div>'
          }
          this.showSpinner = false
          this.$refs.loadmore.onBottomLoaded()
          setTimeout(() => {
            if (document.querySelector('.loadmore_box')) {
              document.querySelector('.loadmore_box').scrollTop = 0
            }
          }, 10)

          this.listenClick()
          this.popupVisible = false
        })
        .catch(() => {
          this.showSpinner = false
        })
    },
    clearSide () {
      var divs = document.querySelectorAll('.sideMenu_div .active')
      for (var i = 0; i < divs.length; i++) {
        divs[i].className = ''
      }
    },
    listenClick () {
      setTimeout(() => {
        var goods = document.querySelectorAll('.goods_divTwo')
        for (var i = 0; i < goods.length; i++) {
          goods[i].addEventListener('click', e => {
            this.$router.push({
              path: '/troubleshootingInfo',
              query: { id: e.currentTarget.getAttribute('tag') }
            })
          })
        }
      }, 50)
    },
    noData () {
      setTimeout(() => {
        var strs = document.querySelector('.swiper-slide-active .goods_box')
        if (
          strs &&
          !document.querySelector('.swiper-slide-active .goods_box .noDataing')
        ) {
          strs.innerHTML += '<div class="noDataing">没有更多数据了</div>'
        }
      }, 10)
    },
    selectSideMenu (e) {
      // var divs = e.target.parentElement.querySelectorAll("div");
      // for (var i = 0; i < divs.length; i++) {
      //   divs[i].className = "";
      // }
      // e.target.className = "active";
      if (e.target.className.indexOf('active') >= 0) {
        e.target.className = ''
      } else {
        var divs = e.target.parentElement.querySelectorAll('div')
        for (var i = 0; i < divs.length; i++) {
          divs[i].className = ''
        }
        e.target.className = 'active'
      }
    },
    openSx () {
      this.popupVisible = true
    },
    tabClick (index) {
      var time = setInterval(() => {
        if (document.querySelector('.m_menu_scroll')) {
          clearInterval(time)
          document
            .querySelector('.m_menu_scroll')
            .scrollTo(
              document.querySelectorAll('.m_menu_scroll div')[0].clientWidth *
                index,
              0
            )
        }
      }, 500)
      this.currentindex = index
      this.mySwiperTwo.slideTo(this.currentindex + 1, 500, false)
      this.categorySxList = this.categoryList[this.currentindex].tagCategory
      this.getList()
    },
    handleTopChange (status) {
      this.topStatus = status
    },
    loadTop () {
      setTimeout(() => {
        this.$refs.loadmore.onTopLoaded()
      }, 1000)
    },
    toBack () {
      history.back()
    },
    getDate () {
      if (this.list.length == 0) {
        this.noDataing = true
      }
    },
    loadMore () {},
    loadBottom () {
      if (this.flag || !this.getListFlag) {
        return
      }
      this.showSpinner = true
      this.flag = true
      if (this.categoryList[this.currentindex]) {
        this.str =
          '?article_type=2&category=' + this.categoryList[this.currentindex].id
        var actives = document.querySelectorAll('.sideMenu_div .active')
        for (var i = 0; i < actives.length; i++) {
          this.str += '&tags=' + actives[i].getAttribute('tagid')
        }
        getArticle(
          this.str + '&page=' + this.pageIndex + '&page_size=' + this.pageSize
        )
          .then(res => {
            this.flag = false
            this.list = res.data.results
            if (this.list.length < this.pageSize) {
              this.noData()
            }
            var strs = document.querySelector(
              '.swiper-slide-active .goods_box'
            )
            for (var i = 0; i < this.list.length; i++) {
              strs.innerHTML +=
                '<div class="goods_divTwo" tag=' +
                this.list[i].id +
                '><div>' +
                this.list[i].title +
                '</div><div class="m_clearLR goods_msg_box">' +
                '<div class="m_floatL">' +
                (this.list[i].views ? this.list[i].views : '0') +
                '人阅读</div><div class="m_floatL createdTime">' +
                this.partFilter(this.list[i].created_at) +
                '</div></div></div>'
            }
            this.showSpinner = false
            var timer = setInterval(() => {
              // this.openTouch();
              if (document.querySelector('.loadmore_box')) {
                //   clearInterval(timer);
                // document.querySelector(".loadmore_box").scrollTop = 0;
                if (document.querySelector('.swiper-slide-active .goods_box')) {
                  clearInterval(timer)
                  //  document.querySelector(".loadmore_box").scrollTop = 0;
                  if (
                    document.querySelector('.swiper-slide-active .goods_box')
                      .clientHeight > 0
                  ) {
                    document.querySelector('.swiper-container').style.height =
                      document.querySelector('.swiper-slide-active .goods_box')
                        .clientHeight + 'px'
                  }
                }
              }
            }, 50)

            this.listenClick()
            setTimeout(() => {
              this.pageIndex++
              if (this.$refs.loadmore) {
                this.$refs.loadmore.onBottomLoaded()
              }
              // if (document.querySelectorAll(".swiper-slide-active .goods_box div").length <= this.num)
              //   setTimeout(() => {
              //     if (document.querySelector(".loadmore_box")){
              //       alert('123')
              //       document.querySelector(".loadmore_box").scrollTop = 0;
              //       }
              //   }, 1);
            }, 500)
          })
          .catch(() => {
            this.noData()
            this.flag = false
            this.$refs.loadmore.onBottomLoaded()
            this.showSpinner = false
          })
      }
    },
    getList () {
      // this.sum++;
      // this.pageIndex = 1;
      // this.clearSide();

      this.str =
        '?article_type=2&category=' + this.categoryList[this.currentindex].id
      var actives = document.querySelectorAll('.sideMenu_div .active')
      for (var i = 0; i < actives.length; i++) {
        this.str += '&tags=' + actives[i].getAttribute('tagid')
      }
      this.list = []
      this.showSpinner = true
      getArticle(
        this.str + '&page=' + this.pageIndex + '&page_size=' + this.pageSize
      )
        .then(res => {
          this.popupVisible = false
          this.total = res.data.count
          this.getListFlag = true
          this.list = res.data.results
          var timer = setInterval(() => {
            // this.openTouch();
            if (document.querySelector('.loadmore_box')) {
              if (document.querySelector('.swiper-slide-active .goods_box')) {
                clearInterval(timer)
                document.querySelector('.loadmore_box').scrollTop = 0
                // if (
                //   document.querySelector(".swiper-slide-active .goods_box")
                //     .clientHeight > 0
                // )
                //   document.querySelector(".swiper-container").style.height =
                //     document.querySelector(".swiper-slide-active .goods_box")
                //       .clientHeight + "px";
              }
            }
          }, 50)
          // for(var i = 0 ; i < 20 ; i++){
          //   this.list.push(i)
          // }

          if (!this.openFlag) {
            this.openFlag = true
            setTimeout(() => {
              this.mySwiperTwo = new Swiper('.swiper-container', {
                loop: true,
                observer: true, // 修改swiper自己或子元素时，自动初始化swiper
                observeParents: false // 修改swiper的父元素时，自动初始化swiper
              })

              var strs = document.querySelector(
                '.swiper-slide-active .goods_box'
              )
              strs.innerHTML = ''
              for (var i = 0; i < this.list.length; i++) {
                strs.innerHTML +=
                  '<div class="goods_divTwo" tag=' +
                  this.list[i].id +
                  '><div>' +
                  this.list[i].title +
                  '</div><div class="m_clearLR goods_msg_box">' +
                  '<div class="m_floatL">' +
                  (this.list[i].views ? this.list[i].views : '0') +
                  '人阅读</div><div class="m_floatL createdTime">' +
                  this.partFilter(this.list[i].created_at) +
                  '</div></div></div>'
              }
              this.showSpinner = false
              this.$refs.loadmore.onBottomLoaded()
              this.listenClick()
              // if (this.list.length < this.pageSize) {
              //   this.noData();
              // }
              if (this.mySwiperTwo) {
                this.mySwiperTwo.on(
                  'slideChangeTransitionStart',
                  swiperHere => {
                    var time = setInterval(() => {
                      if (document.querySelector('.m_menu_scroll')) {
                        clearInterval(time)
                        document
                          .querySelector('.m_menu_scroll')
                          .scrollTo(
                            document.querySelectorAll('.m_menu_scroll div')[0]
                              .clientWidth * this.mySwiperTwo.realIndex,
                            0
                          )
                      }
                    }, 500)

                    this.currentindex = this.mySwiperTwo.realIndex
                    this.categorySxList = this.categoryList[
                      this.currentindex
                    ].tagCategory
                    this.pageIndex = 1
                    this.getList()
                  }
                )
              }
            }, 500)
          } else {
            var strs = document.querySelector(
              '.swiper-slide-active .goods_box'
            )
            strs.innerHTML = ''
            for (var i = 0; i < this.list.length; i++) {
              strs.innerHTML +=
                '<div class="goods_divTwo" tag=' +
                this.list[i].id +
                '><div>' +
                this.list[i].title +
                '</div><div class="m_clearLR goods_msg_box">' +
                '<div class="m_floatL">' +
                (this.list[i].views ? this.list[i].views : '0') +
                '人阅读</div><div class="m_floatL createdTime">' +
                this.partFilter(this.list[i].created_at) +
                '</div></div></div>'
            }
            this.showSpinner = false
            this.$refs.loadmore.onBottomLoaded()
            this.listenClick()
            // if (this.list.length < this.pageSize) {
            //   this.noData();
            // }
          }
        })
        .catch(() => {
          this.total = 0
          this.showSpinner = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/troubleshooting.vue